<div class="star" favoriteToggler 
                  [boardId]="boardId$ | async" 
                  [isFavorite]="isFavorite$ | async" 
                  [class.active]="isFavorite$ | async"></div>